<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>약관동의/{{mberInfo.title}}</span><br/>
					내용을 확인 후 동의해 주세요.
				</div>

				<div class="joinbox agree">
					<div class="inner">
						<div>
							<input type="checkbox" v-model="allCheckMandYn" @click="allCheckMand">
							<label @click="allCheckMand">								
								<strong>전체 동의</strong>
							</label>
						</div>

						<div v-for="(stipMap, idx) in stipList" :key="idx">
							<input type="checkbox" @click="stipClick(idx)" v-model="stipMap.agreeYn">
							<label @click="stipClick(idx)">								
								(필수) {{stipMap.stipNm}}
							</label>
							<span class="more-btn" @click="pageMove(idx)">
								&gt;
							</span>
						</div>

						<div>
							<input type="checkbox" v-model="allCheckSmsYn" @click="allCheckSms">
							<label @click="allCheckSms">								
								(선택) 혜택 및 이벤트 정보 받기 동의
							</label>
						</div>
						<div>
							<input type="checkbox" v-model="mberInfo.emailYn" @click="eamilClick">
							<label @click="eamilClick">								
								이메일
							</label>
							<nbsp />
							<input type="checkbox" v-model="mberInfo.smsYn" @click="smsClick">
							<label @click="smsClick">								
								문자메세지
							</label>
						</div>
					</div>
					<div class="btn-area">
						<div class="mem-reg-bt01" @click="btnSubmit()">동의하고 계속하기</div>
					</div>
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
import { signupTermsMeta } from '@/utils/meta';
import nbsp from '../../components/base/nbsp.vue';
export default {
	metaInfo : signupTermsMeta,
  	components: { nbsp },
	data() {
		return {
			mberInfo : {
				mberDivCd : '',
				title : 'IT프로',
				stipList : [],
				smsYn : false,
				emailYn : false,
			},
			stipList : [],
			stipReChk: {},
			forwardData : this.$route.params.forwardData,
			allCheckMandYn : false,
			allCheckSmsYn : false,
		}
	},

	beforeMount() {
		if(this.forwardData) {
			this.setMberInfo();
			this.selectStipCont();

			if(this.mberInfo.mberDivCd == '22') {
				this.mberInfo.title = '클라이언트';
			}else if(this.mberInfo.mberDivCd == '31') {
				this.mberInfo.title = '파트너사';
			}


		}else {
			this.$router.replace({name : 'MEM003M01'});
		}
	},

	methods : {
		pageMove(idx) {
			var routeData = '';

			if(idx == 0) {
				routeData = this.$router.resolve({name: 'MAN002M01'});
			} else if(idx == 1) {
				routeData = this.$router.resolve({name: 'MAN002M02'});
			}

			window.open(routeData.href);	
		},
		
		setMberInfo() {
			this.mberInfo.mberDivCd = this.forwardData.mberDivCd;
		},

		selectStipCont() {
			this.$.httpPost('/api/mem/selectStipCont', {mberDivCd : this.mberInfo.mberDivCd}, '')
				.then(res => {
					if(res.data.resultCode == '000') {
						var resStipList = res.data.data.stipList;
						if(resStipList.length > 2) {
							this.stipList.push(res.data.data.stipList[0]);
							this.stipList.push(res.data.data.stipList[1]);
						}else {
							this.stipList = resStipList;
						}
					}
				});
		},
		
		// btnCancel() {
		// 	this.$router.push({name: 'MEM003M01'});
		// },
		
		btnSubmit() {
			var isMove = false;
			var tempStip = {};

			if(this.mberInfo.stipList.length == 0) {
				for(var i in this.stipList) {
					if(this.stipList[i].mandYn == 'Y' && !this.stipList[i].agreeYn) {
						alert('\'' + this.stipList[i].stipNm + '\'은(는) 필수약관 입니다.');
						this.mberInfo.stipList = [];
						return false;
					}

					tempStip = {
						stipDivCd : this.stipList[i].stipDivCd,
						stipVer : this.stipList[i].stipVer,
						agreeYn : this.stipList[i].agreeYn ? 'Y' : 'N'
					}

					this.mberInfo.stipList.push(tempStip);

					// this.mberInfo.stipList[i] = {
					// 	stipDivCd : this.stipList[i].stipDivCd,
					// 	stipVer : this.stipList[i].stipVer,
					// 	agreeYn : this.stipList[i].agreeYn ? 'Y' : 'N'
					// }

					isMove = true;
				}
			}

			if(isMove) this.$router.push({name : 'MEM004M02', params : {forwardData : this.mberInfo}});
		},

		stipClick(div) {
			if(this.stipList[div] != undefined) {
				if(this.stipList[div].agreeYn) {
					this.stipList[div].agreeYn = false;
				} else {
					this.stipList[div].agreeYn = true;
				}
			}
			this.$forceUpdate();
			this.statusCheck();
		},

		allCheckMand() {
			if(this.allCheckMandYn) {
				this.allCheckMandYn = false;
				for(var i = 0; i < this.stipList.length; i++) {
					this.stipList[i].agreeYn = this.allCheckMandYn;
				}
				this.allCheckSmsYn = this.allCheckMandYn;
				this.mberInfo.smsYn = this.allCheckMandYn;
				this.mberInfo.emailYn = this.allCheckMandYn;
			} else {
				this.allCheckMandYn = true;
				for(var j = 0; j < this.stipList.length; j++) {
					this.stipList[j].agreeYn = this.allCheckMandYn;
				}
				this.allCheckSmsYn = this.allCheckMandYn;
				this.mberInfo.smsYn = this.allCheckMandYn;
				this.mberInfo.emailYn = this.allCheckMandYn;
			}
			
		},

		allCheckSms() {
			if(this.allCheckSmsYn) {
				this.allCheckSmsYn = false;
				this.mberInfo.smsYn = this.allCheckSmsYn;
				this.mberInfo.emailYn = this.allCheckSmsYn;
			} else {
				this.allCheckSmsYn = true;
				this.mberInfo.smsYn = this.allCheckSmsYn;
				this.mberInfo.emailYn = this.allCheckSmsYn;
			}
			this.statusCheck();
		},

		eamilClick() {
			this.mberInfo.emailYn = !this.mberInfo.emailYn;
			this.statusCheck();
		},

		smsClick() {
			this.mberInfo.smsYn = !this.mberInfo.smsYn;
			this.statusCheck();
		},
		
		statusCheck() {
			if(this.mberInfo.smsYn && this.mberInfo.emailYn) {
				this.allCheckSmsYn = true;
			} else {
				this.allCheckSmsYn = false;
				this.allCheckMandYn = false;
			}

			for(var i = 0; i<this.stipList.length; i++) {
					if(this.stipList[i].agreeYn == undefined || this.stipList[i].agreeYn == false) {
						this.allCheckMandYn = false;
						break;
					} else if(this.allCheckSmsYn) {
						this.allCheckMandYn = true;
					}
				}
			
		}

	}
}
</script>